import classnames from 'classnames';
import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
// import loadable from '@loadable/component';

import 'lib/global.scss';

import AppContext from 'AppContext';
import PopupMultiStep from 'organisms/PopupMultiStep';
import PagePromoNew from 'organisms/PagePromoNew';
// import Popup from 'pages/popup-frame';
//import { lazy } from 'lib/helpers';

// import Header from 'organisms/HeaderClone';
// import Footer from 'organisms/FooterClone';
// const Header = loadable( () => 'organisms/HeaderClone' );
// const Footer = loadable( () => 'organisms/FooterClone' );

/**
 *  The App.
 */
const App = React.memo( ( { children, ...p } ) => {

   // eslint-disable-next-line
  const AppState = React.useContext( AppContext );

  const { sanityGlobalPromo } = useStaticQuery( graphql`
    query {
      sanityGlobalPromo {
        assetBlurb
        assetHeading
        assetHighlights {
          heading
          icon {
            asset {
              url
              metadata {
                lqip
              }
            }
          }
        }
        ctaText
        formBlurb
        formHeading
        label
        lead
        ls
        lss
        submittedMessage
      }
    }
  ` );


  /* ------ = Output. = --------------------------------------------------------------------- */
  const className = classnames( {
    ['is-showing-cart']: AppState.cartIsShowing,
  } );

  React.useEffect( () => {

    if( typeof window == 'undefined' ) {
      return;
    }

    if(
      document.body.classList.contains( 'cart' ) ||
      document.body.classList.contains( 'checkout' )
    ) {
      return;
    }

    //const sawPopup = sessionStorage.getItem( 'saw_assessment_popup' );
    const sawPopup = window.localStorage.getItem( 'saw_popup_promo' );

    if( sawPopup ) {
      return;
    }

    window.closeIFrame = () => {

      const iframe = document.getElementById( 'popup-iframe' );

      iframe.remove();

    }

    setTimeout( () => {

      const html = `
        <iframe
        id="popup-iframe"
        src="https://www.dartdrones.com/popup-frame"
        style="position:fixed;top:0;left:0;height:100%;width:100%;z-index:9999999999999999"
        />`
      ;

      document.body.insertAdjacentHTML( 'beforeend', html );

      window.localStorage.setItem( 'saw_popup_promo', true );
      //localStorage.setItem( 'saw_assessment_popup', true );

    }, 5000 );

  }, [] );


  return(

    <div id="app" className={ className }>

      { children }

      <PagePromoNew { ...sanityGlobalPromo } />

    </div>

  );

} );

export default App;
